import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  targetSelfRating: {
    "& .MuiSelect-selectMenu": {
      border: "solid 1px #EDEDED",
      borderRadius: 4,
      // background: "#FAFAFA",
      fontSize: 13,
      padding: "4px 15px 4px 4px",
    },
    "& .MuiInput-underline:before": {
      border: "none",
    },
    "& .MuiInputBase-root:hover": {
      "& .MuiInput-underline:before": {
        border: "none",
      },
    },
    popper: {
      height: 200,
      width: 250,
      zIndex: "2 !important",
      '&[x-placement*="bottom"] $arrow': {
        top: 0,
        left: 0,
        marginTop: "-0.9em",
        width: "3em",
        height: "1em",
        "&::before": {
          borderWidth: "0 1em 1em 1em",
          borderColor: `transparent transparent ${theme.palette.background.paper} transparent`,
        },
      },
      '&[x-placement*="top"] $arrow': {
        bottom: 0,
        left: 0,
        marginBottom: "-0.9em",
        width: "3em",
        height: "1em",
        "&::before": {
          borderWidth: "1em 1em 0 1em",
          borderColor: `${theme.palette.background.paper} transparent transparent transparent`,
        },
      },
      '&[x-placement*="right"] $arrow': {
        left: 0,
        marginLeft: "-0.9em",
        height: "3em",
        width: "1em",
        "&::before": {
          borderWidth: "1em 1em 1em 0",
          borderColor: `transparent ${theme.palette.background.paper} transparent transparent`,
        },
      },
      '&[x-placement*="left"] $arrow': {
        right: 0,
        marginRight: "-0.9em",
        height: "3em",
        width: "1em",
        "&::before": {
          borderWidth: "1em 0 1em 1em",
          borderColor: `transparent transparent transparent ${theme.palette.background.paper}`,
        },
      },
    },
    arrow: {
      position: "absolute",
      fontSize: 7,
      width: "3em",
      height: "3em",
      "&::before": {
        content: '""',
        margin: "auto",
        display: "block",
        width: 0,
        height: 0,
        borderStyle: "solid",
      },
    },
    paper: {
      overflow: "auto !important",
      padding: 4,
    },
    "& .commentA, & .MuiDialogActions-root": {
      width: "500px",
      margin: "0 auto",
      display: "block",
      "& .MuiTypography-root": {
        color: "#5C5C5C !important",
        marginBottom: "5px",
        textAlign: "left !important",
        fontSize: "14px !important",
      },
      "&. MuiOutlinedInput-input": {
        fontSize: "12px",
      },
      " & .MuiFormLabel-root.MuiInputLabel-root": {
        textAlign: "left",
      },
      "&.MuiDialogActions-root": {
        textAlign: "right",
        padding: "0",
        marginTop: "25px",
      },
    },
  },
  topStrengthsLabel: {
    fontSize: "13px",
    cursor: "pointer",
    color: "#07519C",
  },
  popover: {
    "& .MuiChip-label": {
      maxWidth: 150,
    },
  },
}));
